import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const molImageUrl = `${environment.appUrl}/breeze/MolImage`;

export type KeyValuePair = { Key: string, Value: number };

@Injectable()
export class MolImageService {

    constructor(public _http: HttpClient) {
    }


    public getMaterialImage(materialId: number): Promise<any> {
        const url = this.getImageUrlForMaterial(materialId);
        return this._http.get<string>(url, { responseType: 'text' as any})
            .toPromise()
            .catch(() => {
            });
    }

    public getBase32SmileUrl(materialId: number): Promise<any> {
        const url = `${molImageUrl}/Base32SmileByMaterial?id=${materialId}`;
        return this._http.get<string>(url, { responseType: 'text' as any})
            .toPromise()
            .then(r => {
                if (r) {
                    return `${environment.appUrl}/cache/${r}`;
                }
                return null;
            })
            .catch(() => {
            });
    }

    public getImageUrlForMaterial(materialId: number) {
        return `${molImageUrl}/ByMaterial?id=${materialId}`;
    }

    public getImageUrlForSmile(smile: string) {
        return `${molImageUrl}/BySmile?smile=${smile}`;
    }

    public getMoleculeFromMaterial(materialId: number): Promise<any> {
        const url = `${molImageUrl}/MoleculeFromMaterial?materialId=${materialId}`;
        return this._http.get<string>(url, { responseType: 'text' as any})
            .toPromise()
            .catch(() => {
            });
    }

    public getBase32SmileUrlWithSize(materialId: number, size: string): Promise<any> {
        const url = `${molImageUrl}/Base32SmileByMaterial?id=` + materialId + '&size=' + size;
        return this._http.get<string>(url, { responseType: 'text' as any})
            .toPromise()
            .then(r => {
                if (r) {
                    return `${environment.appUrl}/cache/${r}`;
                }
                return null;
            }).catch(er => { });
    }

    public getFingerprintTypes(): Promise<KeyValuePair[]> {
        const url = `${molImageUrl}/GetFingerprintTypes`;
        return this._http.get<KeyValuePair[]>(url)
            .toPromise();

    }

    // public getImageUrlForMaterialWithSize(materialId: number, imageSize: string) {
    //     return 'breeze/MolImage/ByMaterial?id=' + materialId + '&size=' + imageSize;
    // }

}
